import { jsx } from '@emotion/react/jsx-runtime';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import { IconButton } from '@nettbureau/button';
import { createComponentWithRef, useSlot } from '@nettbureau/core';

/**
 * A special icon button used to clear inputs.
 */ const ClearButton = createComponentWithRef((props, ref)=>{
    const [mergedProps, mergedRef] = useSlot('ClearButton', props, ref);
    const { 'aria-label': ariaLabel = 'Clear', as = 'button', ...iconButtonProps } = mergedProps;
    return /*#__PURE__*/ jsx(IconButton, {
        ...iconButtonProps,
        "aria-label": ariaLabel,
        as: as,
        icon: faTimes,
        ref: mergedRef,
        variant: "plain"
    });
});

export { ClearButton };
//# sourceMappingURL=clear-button.js.map
